import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../src/core/api/axiosClientDMS";

const initialState: any = {
  isLoading: false,
  error: null,
  filter: {},
  simCardData: {},
  isLoadingSimCardData: false,
  simCardDataByID: {},
  isLoadingSimCardDataByID: false,
};

export const getSimCardData: any = createAsyncThunk(
  "content/getSimCardData",
  async ({
    PageNumber,
    pageSize,
    SortBy,
    SortDirection,
    TcCode,
    SiteCode,
    BlockCode,
    searchText,
    signal,
  }: any) => {
    const res = await axios.get(`/dmsapp/SimCard/getall`, {
      params: {
        PageNumber,
        pageSize,
        SortBy,
        SortDirection,
        TcCode,
        SiteCode,
        BlockCode,
        searchText,
      },
      signal,
    });

    const data = await res.data;
    return data;
  },
);

export const addSimCard: any = createAsyncThunk(
  "content/addSimCard",
  async ({ payload }: any) => {
    const res = await axios.post(`/dmsapp/SimCard`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await res.data;
    return data;
  },
);

export const getSimCardDataByID: any = createAsyncThunk(
  "content/getSimCardDataByID",
  async ({ id }: any) => {
    const res = await axios.get(`/dmsapp/SimCard`, {
      params: { id },
    });

    const data = await res?.data?.data;
    return data;
  },
);

export const editSimCardDataByID: any = createAsyncThunk(
  "content/editSimCardDataByID",
  async ({ payload, id }: any) => {
    const res = await axios.put(`/dmsapp/SimCard`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
      params: { id },
    });

    const data = await res.data;
    return data;
  },
);

export const simCardSlice = createSlice({
  name: "simCard",
  initialState,
  reducers: {
    setFilter(state, action) {
      state.filter = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSimCardData.pending, (state) => {
      state.isLoadingSimCardData = true;
    });
    builder.addCase(getSimCardData.fulfilled, (state, action) => {
      state.isLoadingSimCardData = false;
      state.simCardData = action.payload;
    });
    builder.addCase(getSimCardData.rejected, (state, action) => {
      state.isLoadingSimCardData = false;
      state.error = action.error.message;
    });
    builder.addCase(addSimCard.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(addSimCard.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(addSimCard.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });
    builder.addCase(getSimCardDataByID.pending, (state) => {
      state.isLoadingSimCardDataByID = true;
    });
    builder.addCase(getSimCardDataByID.fulfilled, (state, action) => {
      state.isLoadingSimCardDataByID = false;
      state.simCardDataByID = action.payload;
    });
    builder.addCase(getSimCardDataByID.rejected, (state, action) => {
      state.isLoadingSimCardDataByID = false;
      state.error = action.error.message;
    });
    builder.addCase(editSimCardDataByID.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(editSimCardDataByID.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(editSimCardDataByID.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });
  },
});
export const { setFilter } = simCardSlice.actions;

export default simCardSlice.reducer;
